import baseScmService from 'services/baseScmService';

const academyTopicService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    searchAcademyTopic: build.query({
      query: ({ topicType, keyword }) => ({
        method: 'GET',
        url: '/academy-topics/search/',
        params: { 'filter[type_of_topic]': topicType, q: keyword },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazySearchAcademyTopicQuery } = academyTopicService;

export default academyTopicService;
